import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpreact = (props) => /* @__PURE__ */ _jsx("svg", {
	style: { transform: "rotate(180deg)" },
	width: 5,
	height: 3,
	viewBox: "0 0 5 3",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.33333 3L0.0239327 4.35022e-07L4.64273 3.12331e-08L2.33333 3Z" })
});
export default SvgArrowUpreact;
